import React, { Fragment, useEffect, useState } from 'react'
import ProductsList from './TagFunctionality.jsx/ProductsList'
import OrdersList from './TagFunctionality.jsx/OrdersList'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { sendPrivateMessageAction } from '../../redux/actions/chatActions'
import { clearErrors } from '../../redux/actions/userActions'
import { SEND_PRIVATE_MESSAGE_RESET } from '../../redux/constants/chatConstants'
import { uploadToCloudinary } from '../../utils/uploadToCloudinary'
import store from "../../store"

const SendMessage = ({ user }) => {


    const dispatch = useDispatch()

    const { loading, error, message: msg } = useSelector(state => state.sendPrivateMessage)

    const [showProducts, setShowProducts] = useState(false)
    const [productID, setProductID] = useState(null)
    const [productData, setProductData] = useState({})
    const [showOrders, setShowOrders] = useState(false)
    const [orderID, setOrderID] = useState(null)
    const [OrderData, setOrderData] = useState({})
    const [image, setImage] = useState("")
    const [imageURL, setImageURL] = useState("")
    const [message, setMessage] = useState("")

    const getToastStyle = (color) => ({
        background: document.documentElement.classList.contains("dark") ? "#111827" : "#fff",
        color,
        border: document.documentElement.classList.contains("dark") ? "1px solid #243044" : "1px solid rgba(0,0,0,0.05)",
        padding: "6px 20px",
        borderRadius: "30px",
        fontSize: "16px",
        width: "auto",
        maxWidth: "fit-content",
        display: "flex",
    });


    const handleClassName = (ProductStatus) => {


        if (ProductStatus === "ACTIVE") return "text-green-600 bg-green-100";
        if (ProductStatus === "SYSTEM_CANCELLED") return "text-red-600 bg-red-100";
        if (ProductStatus === "SUSPENDED") return "text-orange-600 bg-orange-100";
        if (ProductStatus === "INACTIVE") return "text-purple-600 bg-purple-100";
        if (ProductStatus === "PAUSED") return "text-orange-600 bg-orange-100";

    }






    const handleClassNameForOrder = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }



    const handleFileChange = (setImage, setPreview) => (e) => {
        const file = e.target.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }


        e.target.value = null;
    };





    const sendMessageFunction = async () => {


        if (loading) return

        if (!message && !imageURL) {

            toast.error("Cannot Send Message Without Content", {
                position: "bottom-center",
                style: getToastStyle("#dc2626"),
            });

        }
        try {
            let messageImageURL = null




            if (image) {

                // ✅ START (add this)
                store.dispatch({ type: "UPLOAD_START" });


                // 1️⃣ Upload image



                messageImageURL = await uploadToCloudinary(

                    image,
                    "chats",
                    1, // current
                    1  // total
                );
            }

            // 2️⃣ Send to backend
            const data = {
                image: messageImageURL,
                message,
                related_order_id: orderID,
                related_product_id: productID,
                receiver_id: user?.id
            };

            await dispatch(sendPrivateMessageAction(data));


            // ✅ END (add this)
            store.dispatch({ type: "UPLOAD_END" });

        } catch (err) {
            store.dispatch({ type: "UPLOAD_RESET" });

            toast.error("Image upload failed. Please Check your Internet Connection and then try again.");
        }



    }




    useEffect(() => {


        if (error) {
            toast.error(error, {
                position: "bottom-center",
                style: getToastStyle("#dc2626"),
            });
            dispatch(clearErrors())
        }

        if (msg) {

            dispatch({ type: SEND_PRIVATE_MESSAGE_RESET })
            setMessage("")
            setImage("")
            setImageURL("")
            setProductID(null)
            setProductData({})
            setOrderID(null)
            setOrderData({})
            setImage(null)
        }


    }, [dispatch, msg, error])










    return (
        <Fragment>
            <div className="relative">
                {/* Tagged Product */}
                {Object.keys(productData).length > 0 && (
                    <div className={`absolute left-0 w-full ${orderID && imageURL ? "top-[-300%]" : orderID || imageURL ? "top-[-200%]" : "top-[-100%]"}`}>
                        <div className="bg-white border border-gray-100 shadow-lg rounded-lg p-[0.8vmax] flex justify-between items-center mb-[0.5vmax] mx-[1vmax]">
                            <div className="flex gap-[1vmax] items-center">
                                <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-gray-50 border border-gray-100">
                                    <img src={productData?.custom_image} alt="" className="w-full h-full object-cover" />
                                </div>
                                <div>
                                    <h4 className="text-[0.9vmax] font-bold text-gray-800">Product ID: {productData?.id}</h4>
                                    <span className={`text-[0.7vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassName(productData?.status)}`}>
                                        {productData.status?.replaceAll("_", " ").toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            <button 
                                className="w-[1.8vmax] h-[1.8vmax] bg-gray-50 text-gray-400 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                                onClick={() => {
                                    setProductID(null);
                                    setProductData({});
                                }}
                            >
                                <i className="fa-solid fa-xmark text-[0.8vmax]"></i>
                            </button>
                        </div>
                    </div>
                )}

                {/* Tagged Order */}
                {Object.keys(OrderData).length > 0 && (
                    <div className={`absolute left-0 w-full ${imageURL ? "top-[-200%]" : "top-[-100%]"}`}>
                        <div className="bg-white border border-gray-100 shadow-lg rounded-lg p-[0.8vmax] flex justify-between items-center mb-[0.5vmax] mx-[1vmax]">
                            <div className="flex gap-[1vmax] items-center">
                                <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-gray-50 border border-gray-100">
                                    <img src={OrderData?.custom_image} alt="" className="w-full h-full object-cover" />
                                </div>
                                <div>
                                    <h4 className="text-[0.9vmax] font-bold text-gray-800">Order ID: {OrderData?.id}</h4>
                                    <span className={`text-[0.7vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassNameForOrder(OrderData?.status)}`}>
                                        {OrderData.status?.replaceAll("_", " ").toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            <button 
                                className="w-[1.8vmax] h-[1.8vmax] bg-gray-50 text-gray-400 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                                onClick={() => {
                                    setOrderID(null);
                                    setOrderData({});
                                }}
                            >
                                <i className="fa-solid fa-xmark text-[0.8vmax]"></i>
                            </button>
                        </div>
                    </div>
                )}

                {/* Image Preview */}
                {imageURL && (
                    <div className="absolute left-0 top-[-120%] w-full">
                        <div className="bg-white border border-gray-100 shadow-lg rounded-lg p-[0.5vmax] w-[12vmax] mx-[1vmax] relative">
                            <button 
                                className="absolute top-[-0.5vmax] right-[-0.5vmax] w-[1.5vmax] h-[1.5vmax] bg-rose-500 text-white rounded-full flex items-center justify-center hover:bg-rose-600 transition-colors shadow-sm"
                                onClick={() => {
                                    setImage(null);
                                    setImageURL("");
                                }}
                            >
                                <i className="fa-solid fa-xmark text-[0.8vmax]"></i>
                            </button>
                            <img src={imageURL} alt="" className='w-full rounded-md object-cover h-[8vmax]' />
                        </div>
                    </div>
                )}

                {/* Tag Buttons */}
                <div className="flex gap-[0.8vmax] items-center mb-[1vmax]">
                    <button 
                        className="flex items-center gap-[0.3vmax] px-[1vmax] py-[0.4vmax] rounded-full border border-indigo-100 text-indigo-600 bg-indigo-50/50 hover:bg-indigo-50 text-[0.85vmax] font-bold transition-colors"
                        onClick={() => setShowProducts(true)}
                    >
                        <i className="fa-solid fa-tag"></i>
                        <span>Tag Product</span>
                    </button>
                    <button 
                        className="flex items-center gap-[0.3vmax] px-[1vmax] py-[0.4vmax] rounded-full border border-emerald-100 text-emerald-600 bg-emerald-50/50 hover:bg-emerald-50 text-[0.85vmax] font-bold transition-colors"
                        onClick={() => setShowOrders(true)}
                    >
                        <i className="fa-solid fa-tag"></i>
                        <span>Tag Order</span>
                    </button>
                </div>

                {/* Input Area */}
                <div className="flex items-end gap-[1vmax] bg-white border border-gray-100 rounded-xl p-[0.8vmax] focus-within:border-indigo-200 focus-within:shadow-sm transition-all shadow-sm">
                    {/* Image Upload Button */}
                    <button
                        className="w-[2.5vmax] h-[2.5vmax] bg-white text-gray-500 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors flex-shrink-0 shadow-sm border border-gray-100"
                        onClick={() => document.getElementById("sendMessageImage").click()}
                    >
                        <i className="fa-regular fa-images text-[1.2vmax]"></i>
                    </button>

                    {/* Textarea */}
                    <div className="flex-1 min-w-0">
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Type a message..."
                            rows={1}
                            className="w-full bg-transparent outline-none text-[0.95vmax] font-medium text-gray-700 placeholder-gray-400 resize-none max-h-[6rem] my-scroll py-[0.4vmax]"
                            onInput={(e) => {
                                e.target.style.height = "auto";
                                e.target.style.height = e.target.scrollHeight + "px";
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    sendMessageFunction();
                                }
                            }}
                        />
                    </div>

                    {/* Send Button */}
                    <button 
                        className={`w-[2.5vmax] h-[2.5vmax] rounded-full flex items-center justify-center transition-colors flex-shrink-0 shadow-sm
                            ${!message && !image ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "bg-indigo-600 text-white hover:bg-indigo-700"}`}
                        disabled={!message && !image}
                        onClick={sendMessageFunction}
                    >
                        <i className="fa-solid fa-arrow-right text-[1vmax]"></i>
                    </button>
                </div>
            </div>

            <input
                id="sendMessageImage"
                type="file"
                accept="image/png, image/jpeg"
                onChange={handleFileChange(setImage, setImageURL)}
                className="hidden"
            />
            
            {/* Modals */}
            {showProducts && (
                <ProductsList
                    setShowProducts={setShowProducts}
                    productID={productID}
                    setProductID={setProductID}
                    setProductData={setProductData}
                />
            )}
            {showOrders && (
                <OrdersList
                    setShowOrders={setShowOrders}
                    orderID={orderID}
                    setOrderID={setOrderID}
                    setOrderData={setOrderData}
                />
            )}
        </Fragment>
    )
}

export default SendMessage
